// extracted by mini-css-extract-plugin
export default {"canvas":"DarkGlowTracker_canvas__3EtOq"};